import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ClockIcon from '@lt/components/icons-react/rebrand/Clock';

import { i18n } from '@lt/localization';
import { getRemainingTime } from '../../utils/dateUtils';

const TIMER_TIMEOUT = 1000;

const StyledDuration = styled.span`
  text-align: left;
`;

class PriceChecker extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      remainingTime: this.diff,
    };

    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.start();
  }

  componentWillUnmount() {
    this.stop();
  }

  /**
   * Возвращает разницу между текущим временем и временем, когда нужно обновиться
   * @returns {number} ms
   */
  get diff() {
    const { lastUpdated, timeout } = this.props;
    const diff = lastUpdated + timeout - Date.now();

    if (diff < 0) {
      return 0;
    }

    return diff;
  }

  start() {
    this.update();
    this.timer = setInterval(this.update, TIMER_TIMEOUT);
  }

  stop() {
    clearInterval(this.timer);
  }

  /**
   * Обновляет остаток времени
   */
  update() {
    this.setState({ remainingTime: this.diff });
  }

  render() {
    const { remainingTime } = this.state;
    const { className, fetching, text, fetchingText, lastUpdated, icon } =
      this.props;

    if (!lastUpdated) {
      return null;
    }

    return (
      <span className={className}>
        {fetching || !remainingTime ? (
          <span>{fetchingText}</span>
        ) : (
          <>
            <span>{text}</span>
            <span>{icon}</span>
            <StyledDuration>{getRemainingTime(remainingTime)}</StyledDuration>
          </>
        )}
      </span>
    );
  }
}

PriceChecker.propTypes = {
  className: PropTypes.string,
  lastUpdated: PropTypes.number,
  fetching: PropTypes.bool,
  text: PropTypes.string,
  icon: PropTypes.node,
  fetchingText: PropTypes.string,
  timeout: PropTypes.number.isRequired,
};

PriceChecker.defaultProps = {
  className: null,
  lastUpdated: null,
  text: i18n.t('checkout.billInfo.priceChecker'),
  icon: <ClockIcon height={16} style={{ margin: '0 4px' }} />,
  fetching: false,
  fetchingText: `${i18n.t('checkout.billInfo.priceUpdate')}...`,
};

PriceChecker.StyledDuration = StyledDuration;

export default PriceChecker;
